import Currencies from 'components/Currencies';
//TODO variant b
import { Currencies as CurrenciesVariantB } from 'components/Currencies/variant_b_index';
import SpecialOffers from 'components/SpecialOffers';
import JSCookie from 'js-cookie';
import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ThemeName } from '@sravni/design-system-theme';
import { Grid } from '@sravni/react-design-system';
import { PreFooter } from '@sravni/react-pre-footer';
import { useAbTestingSdk, useIsMobile, useStyles } from '@sravni/react-utils';

import { InviteAFriend } from '../../components/InviteAFriend';
//TODO variant b
import { InviteAFriend as InviteAFriendVariantB } from '../../components/InviteAFriend/variant-b-index';
import { LastDeal } from '../../components/LastDeal';
import Materials from '../../components/Materials';
import Partners from '../../components/Partners';
import PromoBlock from '../../components/PromoBlock';
//TODO variant b
import { PromoBlock as PromoBlockVariantB } from '../../components/PromoBlock/variant-b-index';
import RecentActions from '../../components/RecentActions';
import ServiceMenu from '../../components/ServiceMenu';
//TODO variant b
import { ServiceMenu as ServiceMenuVariantB } from '../../components/ServiceMenu/variant-b-index';
import { SpecialProjects } from '../../components/SpecialProjects';
import { useMetadata } from '../../hooks/metadata';
import { useUser } from '../../hooks/users';
import { fetchBanners } from '../../store/reducers/advertising';
import styles from '../../styles/common.module.scss';

interface IIndexPageProps {
  isShowBVersion: boolean;
  theme: ThemeName;
}

const IndexPage: NextPage<IIndexPageProps> = ({ isShowBVersion, theme }) => {
  const { prefooter } = useMetadata();
  const user = useUser();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const cx = useStyles(styles);

  // TODO тестирование плитки, вариант А это текущий интерфейс (0 в сигме), вариант Б - плитки (1 в сигме)
  const abTestingSdk = useAbTestingSdk();
  const isBtest = abTestingSdk.checkExperimentVariant('915a75f8-efa7-4260', '1');
  console.log({ isBtest });

  const homeCookie = JSCookie.get('AB_HOME_DIRECT');
  // @ts-expect-error
  const isNeedBVersion = isShowBVersion || homeCookie === 'always';

  useEffect(() => {
    dispatch(
      fetchBanners({
        params: {
          BannerTypes: ['top', 'teaserInPropositions'],
          Page: 'home',
        },
      }),
    );
  }, [dispatch]);

  return (
    <>
      <div className={cx('universal-wrapper')}>{user && <LastDeal userId={user.sub} />}</div>
      {!isBtest ? (
        <>
          <PromoBlock darkTheme={theme === ThemeName.guinness} />
          <ServiceMenu />
          <div
            className={cx(
              'universal-wrapper',
              'universal-wrapper--full-width-on-mobile',
              isMobile ? 'h-mt-28' : 'h-mt-76',
            )}
          >
            <Grid.Row justify={'space-between'} gutter={[32, 16]} wrap={isMobile} align={'middle'}>
              <Grid.Col span={isMobile ? 12 : 6}>
                <InviteAFriend />
              </Grid.Col>
              <Grid.Col span={isMobile ? 12 : 6}>
                <Currencies />
              </Grid.Col>
            </Grid.Row>
          </div>
        </>
      ) : (
        // TODO variant b
        <>
          <PromoBlockVariantB darkTheme={theme === ThemeName.guinness} />
          <ServiceMenuVariantB />
          <div className={cx('whiteBackground')}>
            <div
              className={cx(
                'universal-wrapper',
                'universal-wrapper--full-width-on-mobile',
                'whiteBackground',
                'inviteWrapper',
                'h-pt-8',
              )}
            >
              <Grid.Row
                className={cx('')}
                justify={'space-between'}
                gutter={[32, isMobile ? 16 : 0]}
                wrap={isMobile}
                align={'middle'}
              >
                <Grid.Col span={isMobile ? 12 : 6}>
                  <InviteAFriendVariantB />
                </Grid.Col>
                <Grid.Col span={isMobile ? 12 : 6}>
                  <CurrenciesVariantB />
                </Grid.Col>
              </Grid.Row>
            </div>
          </div>
        </>
      )}
      {user?.sub && <RecentActions />}
      <SpecialOffers />
      <Materials />
      <SpecialProjects />
      <Partners />
      <PreFooter columns={prefooter} />
    </>
  );
};

IndexPage.getInitialProps = (ctx: App.ReduxNextPageContext) => {
  const {
    req: { cookies },
  } = ctx;

  const isShowBVersion = Boolean(cookies?.['AB_HOME_DIRECT'] === 'always');

  return {
    isShowBVersion,
    theme: ctx.req.__THEME__,
  };
};

export default IndexPage;
